import { CONTENT_PLATFORM_PROPERTY_NAME, ContentObjectTypes, getContentPropertyValue, getPropertyValue, useContentObjectType } from 'content-management-data-lib';
import { useContentDetailsDataProvider } from 'content-management-details-lib/providers/ContentDetailsDataProvider';
import { PAGE_PROPERTY_NAMES } from 'page-lib/constants/propertyNames';
import { useMemo } from 'react';
import { useFetchPersonalizationVariants } from './useFetchPersonalizationVariants';
export const usePersonalizationVariantsData = () => {
  const {
    contentObject
  } = useContentDetailsDataProvider();
  const {
    contentObjectType
  } = useContentObjectType();
  const isLandingPage = contentObjectType === ContentObjectTypes.LANDING_PAGE;
  const contentId = getPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.ID);
  const personalizationStrategyId = getContentPropertyValue(contentObject, PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID);
  const personalizationVariantStatus = getContentPropertyValue(contentObject, PAGE_PROPERTY_NAMES.PERSONALIZATION_VARIANT_STATUS);
  const shouldFetchData = useMemo(() => isLandingPage && Boolean(personalizationStrategyId) && Boolean(personalizationVariantStatus), [isLandingPage, personalizationStrategyId, personalizationVariantStatus]);
  const data = useFetchPersonalizationVariants({
    contentId,
    shouldFetchData
  });
  return data;
};